module.exports = __webpack_public_path__ + "media/images/sprite-payment-38ba8d02746b8e2bad1e27f7c2c55e2c.svg";